<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file AccountTickets.vue is part of event_pass_client.dev.            -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - AccountTickets.vue can not be copied and/or distributed                   -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--Created by keni.-->
<!--User: keni-->
<!--Date: 22/03/2018-->
<!--Time: 14:57-->
<!--displays the ticket purchased and the details for the ticket-->
<template>
    <div>
        <div data-tickets-list class="d-flex justify-content-between flex-column flex-md-row pb-2">

            <div class="w-100 d-flex justify-content-between align-items-center">

                <!--display the icon-->
                <div class="pr-3" data-type="ticket-type">
                    <div class="ticket-icon">
                        <div :class="ticketTypeIconClass(sale_local.finalized_ticket)"
                        ></div>
                    </div>
                </div>
                <a v-if="createLink()"
                   class="p-2 cursor-pointer text-body"
                   :href="createLink()"
                   target="_blank"
                >
                    <i class="material-icons" aria-hidden="true">location_on</i>
                </a>
                <a v-if="view_sale !== ''"
                   target="_blank"
                   :href="view_sale"><i class="material-icons">email</i></a>



                <!-- {{ this.sale }}
                {{ sale_local.ticket.ticket_data.type }} -->
                <!--info button inside ticket details list-->
                <ticket-details-list
                    :bundle_title="bundle_title"
                    :ticket_route="ticket_route"
                    :ticket="sale_local.finalized_ticket"
                    :show_icon="false"
                    :show_time="true"
                    :description_event="true"
                    @show_ticket_description="ticketDescriptionSelected"
                    class="w-100"
                />
            </div>
            <!--we only allow single ticket refunds-->
            <div v-if="sale_local.ticket.ticket_type === 'single' || sale_local.ticket.ticket_type === 'addon'">
                <template v-if="!is_bundle(sale_local.ticket)">
                    <button v-if="canRefund() "
                            v-on:click="refundRequest()"
                            class="ml-0 ml-md-2 mb-0 float-right float-md-none btn btn-warning btn-sm"
                    >
                        refund
                    </button>
                    <button v-else-if="wasCancelled()"
                            class="ml-0 ml-md-2 mb-0 btn btn-info disabled btn-sm"
                    >
                        refunded
                    </button>
                    <button class="ml-0 ml-md-2 mb-0 btn btn-success disabled btn-sm"
                            v-else-if="hasEnded()"
                    >
                        ended
                    </button>
                </template>

            </div>
        </div>


        

        <coach-seat-selection
            v-if="showCoachSeatSelector"
            v-on:childToParent="onSeatSelectionInChild"
            v-bind:sale="this.sale"
            v-bind:events="this.sale_local.ticket.events"
        /> 
        <div class="bg-level-5"
             v-if="ticket_descriptions.hasOwnProperty(sale_local.ticket_id) && ticket_descriptions[sale_local.ticket_id].active === true"
             v-html="ticket_descriptions[sale_local.ticket_id].html"
        ></div>
    </div>
</template>

<script>
    import {ticket_types} from '../../../../../../app/Shared/Resources/Assets/js/helpers/ticketIcons';
    import lang from '../../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import {_} from 'underscore';

    Vue.component('ticket-details-list', require('../../tickets/TicketDetailsList'));
    Vue.component('round-button', require('../../../../../../app/Shared/Resources/Assets/js/components/buttons/RoundButton'));
    // Vue.component('event-list', require('../../lists/EventList'));
    Vue.component('coach-seat-selection', require('../../tickets/CoachSeatSelection'));

    export default {
        name: "account-tickets",
        components: {},
        // props: ['routes', 'sale', 'events','ticket_route'],
        props: {
            /**
             * @param {object} routes.refund
             * @param {object} routes
             **/
            bundle_title:{
                type:String,
                default:''
            },
            routes: {
                type: Object
            },
            view_sale: {
                type: String,
                default: ''
            },
            map_url: {
                type: Object
            },
            sale: {
                type: Object
            },
            user: {
                type: Object
            },
            events: {
                type: Object
            },
            ticket_route: {
                type: Object,
                default: function () {
                    return {};
                }
            },
        },
        created() {
            this.sale_local = this.sale;
            console.log(this.sale.ticket.selected_seat);
            console.log(this.sale);
        },
        destroyed() {
        },
        mounted() {
        },
        data() {
            return {
                /**
                 * @property sale_local.finalized_ticket
                 * @property sale_local.price_paid
                 * @property sale_local.refunds
                 * @namespace sale_local
                 */
                sale_local: {},
                ticket_descriptions: {},
                showCoachSeatSelector: false,
                selected_seat: this.sale.ticket.selected_seat ? this.sale.ticket.selected_seat : '?',
            }
        },
        methods: {
            isCoachTicket(ticket) {
                return ticket.entity.entity_type_slug == 'bus' ? true : false;
            },
            onSeatSelectionInChild(seat)  {
                this.selected_seat = seat
            },
            showSeatSelector() {
                this.showCoachSeatSelector = !this.showCoachSeatSelector
            },
            is_bundle(ticket) {
                
                if (ticket.hasOwnProperty('is_bundle')) {
                    return ticket.is_bundle > 0;
                }
                return false;
            },
            createLink() {
                let link = 'https://www.google.com/maps/place/?q=place_id:';
                if (typeof this.map_url !== 'undefined' && this.map_url !== null) {
                    return link + this.map_url.place_id;
                } else {
                    // console.log('this.map_url', this.map_url); // this will be session tickets at the moment will need to get the season tickets details
                    return null;
                }
            },
            ticketDescriptionSelected(ticket) {
                let self = this;
                // console.log('ticketDescriptionSelected', 'ticket',ticket);

                self.$set(self.ticket_descriptions, ticket.id, {
                    active: ticket.set_active,
                    html: ticket.description
                })
            },
            /**
             *
             **/
            hasEnded() {
                let self = this;
                let sale_content = self.sale_local;

                console.log(sale_content);
                // if active then test
                if (sale_content.status === 'active') {

                    // if tba then its not ended
                    if (sale_content.ticket.events[0].start_date == null) {
                        return false;
                    }

                    let today = new Date(),
                        startOfDay = today.setHours(0, 0, 0, 0);

                    // if single then test
                    if (sale_content.ticket.ticket_type === 'single' || sale_content.ticket.ticket_type === 'addon') {

                        // get the start time
                        let event_start_time = new Date(sale_content.ticket.events[0].start_date);

                        // is the start date in the future
                        return startOfDay >= event_start_time.getTime();
                    }
                }
                // ticket is not active so disable????
                else {
                    // console.log('ticket not active', sale_content);
                    return true;
                }
                return true;
            },
            wasRefunded() {
                let self = this;

                return !_.isEmpty(self.sale_local.refunds);
            },
            wasCancelled() {
                let self = this;

                // console.log('wasCancelled', 'self.sale_local.cancelled_at',self.sale_local.cancelled_at);
                // if (!hasCancelledRecord) {
                // 	return false;
                // }

                // was the record cancelled and not wasRefunded
                // return hasCancelledRecord && !self.wasRefunded();
                return (self.sale_local.cancelled_at !== null);

            },
            /**
             * only refund single tickets
             * @todo do we really only want to refund single tickets? if not then look here...
             * @returns {boolean}
             */
            canRefund() {
                let self = this;

                if (self.wasRefunded()) {
                    return false;
                }

                // cannot refund zero value paid tickets
                if (self.sale_local.price_paid <= 0) {
                    return false;
                }
                // is it active and single type
                if (self.sale_local.status === 'active' && (self.sale_local.ticket.ticket_type === 'single' || self.sale_local.ticket.ticket_type === 'addon')) {
//allow_refunds
                    let ticket = self.sale_local.ticket;
                    if (ticket.hasOwnProperty('ticket_data')) {
                        if (ticket.ticket_data.hasOwnProperty('allow_refunds') && ticket.ticket_data.allow_refunds === 'inactive') {
                            return false;
                        }
                    }
                    // get the start time
                    let event_start_time = new Date(self.sale_local.ticket.events[0].start_date);

                    // remove a day from the start time
                    event_start_time.setDate(event_start_time.getDate() - 1);

                    // is today's date less than the event start time
                    if (Date.now() < event_start_time.getTime()) {
                        return true;
                    }
                }
                return false;
            },
            isZeroValueTicket() {
                let self = this;
                if (self.sale_local.price_paid <= 0) {
                    return true;
                }
                return false;

            },
            cancelZeroValueTicket() {
                //isZeroValueTicket
                let self = this;

                self.setSaleCancelled();
            },
            refundRequest() {
                let self = this;

                if (self.sale_local.refund_requested === true) {
                    // console.error('sale already requested', self.sale_local);
                    self.notify('Whoa there slow down! Please wait a while', 'error');
                    return false;
                }
                $('#refundConfirmation--title')
                    .html('Refunding - ' + lang('title', self.sale_local.finalized_ticket.ticket_data.lang));

                $('#refundConfirmation')
                    .modal();

                $('#refundSubmitButton')
                    .click(function (e) {
                        self.sale_local['refund_requested'] = true;

                        $('#refundConfirmation').modal('hide');
                        self.refundThisSale();
                    });
            },
            setSaleCancelled() {
                let self = this;
                self.sale_local.refund_requested = false;
                self.sale_local.cancelled_at = new Date();
                self.sale_local.status = 'cancelled';

            },
            async refundThisSale() {
                let self = this;

                self.notify('Requesting refund. Please wait...', 'info', true);

                await axios
                    .post(self.routes.refund.url, {
                        sale_content_id: self.sale_local.id
                    })
                    /**
                     * @param   {String} response.data.error_msg    the error message is any
                     * @param   {object} response.data the response data
                     * @param   {object} response the response
                     */
                    .then(function (response) {
                        if (response.data.success) {
                            self.setSaleCancelled();
                            self.notify('Refund successful', 'success');
                        } else {
                            if (response.data.error_msg === 'already_refunded') {
                                self.setSaleCancelled();
                            } else {
                                self.notify(response.data.error_msg, 'error');
                                self.sale_local.refund_requested = false;
                            }
                        }
                    })
                    /**
                     * @param {Number} e.response.status the error response status
                     * @param {object} e.response the error response
                     * @param {object} e the error
                     */
                    .catch(function (e) {
                        // console.log('e', e.response.status);
                        if (e.response.status === 429) {
                            this.notify('Whoa there slow down!', 'error', true);
                        }
                    })
                    .then(function () {

                    });
            },
            notify(msg, type, progress_bar) {
                toastr.options.progressBar = (typeof progress_bar !== 'undefined' && progress_bar !== null)
                                             ? progress_bar
                                             : false;

                switch (type) {
                    case 'error':
                        toastr.error(msg);
                        break;
                    case 'success':
                        toastr.success(msg);
                        break;

                    default:
                        toastr.info(msg);
                }
            },
            first(events) {
                return _.first(events);
            },
            size(obj) {
                return _.size(obj);
            },
            ticketTypeIconClass(ticket) {
                // console.log('ticketTypeIconClass', 'ticket',ticket);
                return ticket_types(ticket.ticket_type, false, 'bg');
            },
            lang(path, object) {
                // console.log('path',path);
                return lang(path, object)
            },
            debug(args) {
                // console.log('args', args);
            }
        },
        computed: {}
    }
</script>

<style scoped>

    .show {
        display:block;
    }
    .hide {
        display:none;
    }
    .select-seat i {
        font-size: 3em;
        margin-right: 10px;
    }
    .select-seat span {
        position: absolute;
        top: 50px;
        left: 36px;
        font-size: 0.8em;
        font-weight: bold;
        background-color: green;
        border-radius: 25px;
        padding: 2px;
        text-align: center;
        width: 23px;
        height: 23px;
    }
    .ticket-icon {
        height: 30px;
        width: 30px;
        font-size: 30px;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/account/AccountTickets.vue